export const StartRoute = {
  Start: 'start',
  CivilProtection: 'civil-protection'
} as const;

export type StartRoute = (typeof StartRoute)[keyof typeof StartRoute];

export type StartParam = {
  [StartRoute.Start]: undefined;
  [StartRoute.CivilProtection]: { count?: number } | undefined;
};
